import styled from 'styled-components';
var AvailabilityList = styled.ul.withConfig({
  displayName: "Availabilitystyles__AvailabilityList",
  componentId: "sc-14qx0om-0"
})(["display:flex;flex-direction:row;margin-bottom:15px;"]);
export { AvailabilityList };